// HH:mm time helpers for admin shift management.
// Spec: docs/admin-shift-management.md §2.1 BR-03, BR-05

export const HHMM_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;

export function isValidHHmm(value: string | undefined | null): boolean {
  return !!value && HHMM_REGEX.test(value);
}

// BR-05: startTime === endTime is rejected. Overnight (end < start) is allowed.
export function sameTime(start?: string | null, end?: string | null): boolean {
  return !!start && !!end && start === end;
}

function toMinutes(hhmm: string): number {
  const [h, m] = hhmm.split(':').map(Number);
  return h * 60 + m;
}

// Ca xuyên đêm: giờ kết thúc nhỏ hơn giờ bắt đầu (kết thúc vào ngày hôm sau).
export function isOvernight(start: string, end: string): boolean {
  return isValidHHmm(start) && isValidHHmm(end) && toMinutes(end) < toMinutes(start);
}

/** "9 giờ", "5 giờ 30 phút" — đã tính ca xuyên đêm. */
export function formatDuration(start: string, end: string): string {
  if (!isValidHHmm(start) || !isValidHHmm(end)) return '';
  let diff = toMinutes(end) - toMinutes(start);
  if (diff <= 0) diff += 24 * 60;
  const h = Math.floor(diff / 60);
  const m = diff % 60;
  if (!h) return `${m} phút`;
  return m ? `${h} giờ ${m} phút` : `${h} giờ`;
}

// Tên ca cũ thường gắn giờ: "HR 09:00-18:00", "MakeUp 09:00 – 12:00".
const NAME_TIME_REGEX = /(\d{1,2}):(\d{2})\s*[-–—~]\s*(\d{1,2}):(\d{2})/;

const pad = (v: string) => v.padStart(2, '0');

/** Khoảng giờ ghi trong tên ca ("09:00-18:00"), hoặc null nếu tên không ghi giờ. */
export function timeInName(name: string): string | null {
  const m = NAME_TIME_REGEX.exec(name || '');
  if (!m) return null;
  return `${pad(m[1])}:${m[2]}-${pad(m[3])}:${m[4]}`;
}

/** Tên ca đã bỏ phần giờ: "HR 09:00-18:00" → "HR". Giờ hiển thị ở cột riêng. */
export function nameWithoutTime(name: string): string {
  return (name || '')
    .replace(NAME_TIME_REGEX, ' ')
    .replace(/[\s\-–—·|:(),]+$/g, '')
    .replace(/^[\s\-–—·|:(),]+/g, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

/** Tên ca ghi một khoảng giờ khác giờ thật (giờ đã sửa sau khi tạo ca). */
export function nameTimeMismatch(name: string, start: string, end: string): string | null {
  const inName = timeInName(name);
  if (!inName) return null;
  return inName === `${start}-${end}` ? null : inName;
}
